module.exports = __webpack_public_path__ + "static/media/placid.1a42eabf.mp3";